import React from "react";
import styled from "styled-components";
import checkAuthorization from "modules/auth/helpers/checkAuthorization";
import { useSelector } from "react-redux";
import { authorizedActionsSelector } from "modules/auth/slice";
import ProfileAvatar from "../entity/components/EntityProfile/ProfileAvatar";
import Creator from "./Creator";
import Edit from "./Edit";

const Container = styled.div`
    padding: 30px;
    background: #ffffff;
    box-shadow: 0px 0px 3px #00000024;
    border-radius: 5px;
    border: 1px solid #00000024;
    display: flex;
`;
const ActionsContainer = styled.div`
    display: flex;
    align-items: center;
`;
function ProfileHeader({ id, name, image, creatorContent, setOpenModal, entityName }) {
    const authorizedActions = useSelector(authorizedActionsSelector());
    const isAuthorizedToEdit = checkAuthorization(authorizedActions, entityName, "update");
    return (
        <Container>
            <ProfileAvatar
                id={id}
                title={name || "N/A"}
                imageUrl={image}
            />
            <ActionsContainer>
                <Creator content={creatorContent} />
                {isAuthorizedToEdit && (
                    <Edit
                        onEdit={setOpenModal}
                        entityName={entityName}
                    />
                )}
            </ActionsContainer>
        </Container>
    );
}

export default ProfileHeader;
